(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-listing"] && !Shopify.designMode) return;
  try {
    
$(function(){
    $('.dropdown').find('.active-sort').text($('.dropdown-menu').find('.dropdown-item.active').text());
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-slider"] && !Shopify.designMode) return;
  try {
    
$(function() {
    new Splide('#brandSlider', {
        arrows: false,
        pagination: false,
        type: 'loop',
        drag: 'free',
        fixedWidth: 130,
        gap: 60
    }).mount(window.splide.Extensions);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
$(function(){
    $('.dropdown').find('.active-sort').text($('.dropdown-menu').find('.dropdown-item.active').text());
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eye-exam"] && !Shopify.designMode) return;
  try {
    
// Update CSS variables when button is clicked
document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.tpb-book-on-grid-button');
    
    buttons.forEach(function(button) {
        button.addEventListener('click', function() {
            const widgetId = this.getAttribute('data-widget-id');
            const bgImage = this.getAttribute('data-bg-image');
            const logoImage = this.getAttribute('data-logo-image');
            
            // Update CSS variables with the clicked button's images
            document.body.style.setProperty('--vex-service', `url('${bgImage}')`);
            document.body.style.setProperty('--vex-logo', `url('${logoImage}')`);
            
            // Open the Tipo widget
            if (typeof Tipo !== 'undefined' && widgetId) {
                Tipo.Booking.openWidget(widgetId);
            }
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
$(function(){
    $('.newsletter-form').each(function () {
        var $form = $(this);
        var $message = $form.find('.newsletter-message');
        var $submit = $form.find('button[type="submit"]');

        $form.on('submit', function (e) {
            e.preventDefault();

            var $email = $form.find('input[name="contact[email]"]');
            if (!$email.val().trim()) {
                $message.text('Please enter your email.').removeClass('is-success').addClass('is-error');
                return;
            }

            $submit.prop('disabled', true);
            $message.text('');

            $.ajax({
                url: $form.attr('action'),
                method: 'POST',
                data: $form.serialize(),
                success: function () {
                    $form[0].reset();
                    $message.text($message.data('success') || 'Thanks for subscribing!').removeClass('is-error').addClass('is-success');
                },
                error: function () {
                    $message.text($message.data('error') || 'There was a problem. Please try again.').removeClass('is-success').addClass('is-error');
                },
                complete: function () {
                    $submit.prop('disabled', false);
                }
            });
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
$(function() {
    new Splide('#announcementSlider', {
        arrows: false,
        pagination: false,
        type: 'loop',
        drag: 'free',
        gap: 40,
        perPage: 1
    }).mount(window.splide.Extensions);
});
document.querySelectorAll('.header-menu-item').forEach(el => {
  if (el.textContent.trim() === 'Sale') {
    el.style.color = 'red';
  }
});

// --- Service menu booking links (Vision7, VisionPlus, etc.): open the Tipo
// widget on click, then redirect to that service's own product page once
// the widget is closed. Detection is based on the widget's real popup
// element (#tpb-widget-popup) appearing then disappearing from the DOM.
document.addEventListener('DOMContentLoaded', function () {
    var pollInterval = null;

    function watchForWidgetClose(redirectUrl) {
        if (!redirectUrl) return; // no page configured — do nothing on close

        var hasOpened = false;
        if (pollInterval) clearInterval(pollInterval);

        pollInterval = setInterval(function () {
            var popupEl = document.getElementById('tpb-widget-popup');

            if (!hasOpened) {
                if (popupEl) hasOpened = true; // confirmed it actually opened
                return;
            }

            if (!popupEl) {
                clearInterval(pollInterval);
                window.location.href = redirectUrl;
            }
        }, 300);

        // Safety net so this never polls forever
        setTimeout(function () { clearInterval(pollInterval); }, 600000);
    }

    document.querySelectorAll('.tpb-service-menu-link').forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            var widgetId = this.getAttribute('data-widget-id');
            var redirectUrl = this.getAttribute('data-redirect-url');
            var bgImage = this.getAttribute('data-bg-image');
            var logoImage = this.getAttribute('data-logo-image');

            // Set the split-screen background photo + logo before opening,
            // same variables the Service section and Eye Exam section use.
            if (bgImage) {
                document.body.style.setProperty('--vex-service', "url('" + bgImage + "')");
            }
            if (logoImage) {
                document.body.style.setProperty('--vex-logo', "url('" + logoImage + "')");
            }

            if (typeof Tipo !== 'undefined' && Tipo.Booking && widgetId) {
                Tipo.Booking.openWidget(widgetId);
                watchForWidgetClose(redirectUrl);
            }
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
$(function() {
    const heroSlideshow = new Splide('#vex-slideshow', {
        type: 'loop',
        interval: 5000,
        speed: 800,
        autoplay: true,
        arrows: false,
        paginationDirection: 'ttb'
    });

    heroSlideshow.on('pagination:mounted', function (data) {
        const $list = $(data.list);
        $list.addClass('splide__pagination--custom');

        var totalItems = data.items.length;
        var bottomNum = 0;

        if (totalItems >= 10) {
            bottomNum = totalItems;
        } else {
            bottomNum = '0' + totalItems;
        }

        // top number
        $('<span/>', { text: '01' }).prependTo($list);

        // bottom number
        $('<span/>', { text: bottomNum }).appendTo($list);
    });

    heroSlideshow.mount();

    var $heroDiv   = $('#vex-slideshow').first();
    var $sliderDiv = $('#vex-slideshow .splide__track').first();
    var $ctaDiv    = $('.hero-cta-block').first();

    if ($sliderDiv.length && $ctaDiv.length) {
        var ctaDivHeight    = $ctaDiv.outerHeight();
        var sliderDivHeight = $sliderDiv.outerHeight();

        $heroDiv.height(sliderDivHeight + (ctaDivHeight / 2));
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
$(function() {
    var mainProductId = $('.rx-summary-product').data('product-id'),
        prescriptionType = '',
        lensType = '',
        lensTypeId = '',
        lensColor = '';

    function numberWithCommas(x){
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }

    // =========================
    // Helper: Show step (Eyeglasses)
    // =========================
    function showStep(stepClass){
        $('#eyeglassesModal .journey-body').addClass('d-none');
        $('#eyeglassesModal .' + stepClass).removeClass('d-none');

        if(stepClass === 'eyeglasses-singlevision-file'){
            // Add to Bag stays disabled until a prescription file is uploaded
            updatePrescriptionSubmit();
        }
    }

    // =========================
    // Prescription upload is required before Add to Bag
    // =========================
    function hasPrescriptionFile(){
        var input = $('#eyeglassesModal .eyeglasses-singlevision-file .file-input')[0];
        return !!(input && input.files && input.files.length);
    }

    function updatePrescriptionSubmit(){
        var $btn = $('#eyeglassesModal .eyeglasses-singlevision-file .rx-form-submit');
        if(hasPrescriptionFile()){
            $btn.removeAttr('disabled');
        } else {
            $btn.attr('disabled', true);
        }
    }

    // Helper: Show step (Contact Lenses)
    function showContactStep(stepSelector){
        $('#contactLensesModal .journey-body').addClass('d-none');
        $('#contactLensesModal ' + stepSelector).removeClass('d-none');
    }

    // =========================
    // Prescription Type
    // =========================
    $('#eyeglassesModal .rx-type').on('change', function(){
        prescriptionType = $(this).data('name');
        var selectedVal = $(this).val();

        $('.rx-type-summary .rx-summary-selection').text(prescriptionType);
        $('.rx-type-summary').removeClass('d-none');

        var $journey = $(this).closest('.journey-body');
        if(selectedVal === 'singlevision'){
            $journey.find('.progress').attr('aria-valuenow', '25');
            $journey.find('.progress-bar').css('width', '25%');
        } else {
            $journey.find('.progress').attr('aria-valuenow', '33');
            $journey.find('.progress-bar').css('width', '33%');
        }

        var $nextBtn = $journey.find('.rx-type-next-btn');
        $nextBtn.data('next-step', 'eyeglasses-' + selectedVal).removeAttr('disabled');
    });

    // =========================
    // Lens Selection
    // =========================
        // Single Vision lens selection — unchanged, still routes to prescription upload or Transitions color step
    $('#eyeglassesModal .rx-singlevision-lens').on('change', function(){
        lensType = $(this).data('name');
        lensColor = '';
        $('.rx-lenscolor-summary').addClass('d-none').find('.rx-summary-selection').text('');
        $('#eyeglassesModal .rx-lens-error').remove();
        var val = $(this).val();

        $('.rx-lens-summary .rx-summary-selection').text(lensType);
        $('.rx-lens-summary').removeClass('d-none');

        var $journey = $(this).closest('.journey-body');

        if(val === 'transgen8'){
            $journey.find('.progress').attr('aria-valuenow', '50');
            $journey.find('.progress-bar').css('width', '50%');
            $journey.find('.rx-type-next-btn').data('next-step', '.eyeglasses-singlevision-transgen8').removeAttr('disabled');
        } else if($(this).data('color-step')){
            // Essilor Eyezen Transitions Gen S: go to the colour step (Next is enabled once the colours have loaded)
            $journey.find('.progress').attr('aria-valuenow', '50');
            $journey.find('.progress-bar').css('width', '50%');
            $journey.find('.rx-type-next-btn').data('next-step', '.eyeglasses-singlevision-eyezen');
            $('.eyeglasses-singlevision-eyezen .rx-eyezen-colors').empty();
            $('.eyeglasses-singlevision-eyezen .rx-eyezen-lens-name').text($(this).data('name'));
            $('.eyeglasses-singlevision-eyezen .rx-type-next-btn').attr('disabled', true);
            lensColor = '';
        } else {
            $journey.find('.progress').attr('aria-valuenow', '66');
            $journey.find('.progress-bar').css('width', '66%');
            $journey.find('.rx-type-next-btn').data('next-step', '.eyeglasses-singlevision-file').removeAttr('disabled');
            $('.eyeglasses-singlevision-file').find('.btn-back').data('prev-step', '.eyeglasses-singlevision');
        }

        updateLensAmountAndVariant($(this), val);
    });

    // Non-Graded lens selection — no prescription needed, so skip straight to Add to Bag
    $('#eyeglassesModal .rx-nongraded-lens').on('change', function(){
        lensType = $(this).data('name');
        var val = $(this).val();

        $('.rx-lens-summary .rx-summary-selection').text(lensType);
        $('.rx-lens-summary').removeClass('d-none');

        var $journey = $(this).closest('.journey-body');

        if(val === 'transgen8'){
            $journey.find('.progress').attr('aria-valuenow', '50');
            $journey.find('.progress-bar').css('width', '50%');
            $journey.find('.rx-type-next-btn').data('next-step', '.eyeglasses-nongraded-transgen8').removeAttr('disabled');
        } else {
            // No prescription upload for Non-Graded — reveal Add to Bag directly
            $journey.find('.progress').attr('aria-valuenow', '100');
            $journey.find('.progress-bar').css('width', '100%');
            $journey.find('.rx-subtotal-transgen8').addClass('d-none');
            $journey.find('.rx-subtotal:not(.rx-subtotal-transgen8)').removeClass('d-none');
        }

        updateLensAmountAndVariant($(this), val);
    });

    // Find a lens product: try data-handle first. If that fails, OR (when data-title is set) the handle
    // belongs to a product with a different title, search the store by the exact product title instead.
    function findLensProduct(handle, title, strictTitle){
        var root = window.Shopify.routes.root;

        function sameTitle(a, b){
            function norm(x){ return String(x).replace(/\s+/g, ' ').trim().toLowerCase(); }
            return norm(a) === norm(b);
        }

        function searchByTitle(){
            if(!title) return $.Deferred().reject().promise();

            return $.getJSON(root + 'search/suggest.json', {
                q: title,
                'resources[type]': 'product',
                'resources[limit]': 10
            }).then(function(res){
                var list = (res && res.resources && res.resources.results && res.resources.results.products) || [],
                    match = null;

                $.each(list, function(_, p){
                    if(sameTitle(p.title, title)){ match = p; return false; }
                });

                if(!match) return $.Deferred().reject().promise();

                console.warn('Lens handle "' + handle + '" is wrong. Real handle for "' + title + '" is "' + match.handle + '" - update data-handle in eyeglasses-singlevision.liquid');
                return $.getJSON(root + 'products/' + match.handle + '.js');
            });
        }

        return $.getJSON(root + 'products/' + handle + '.js').then(function(product){
            if(strictTitle && !sameTitle(product.title, strictTitle)){
                console.warn('Handle "' + handle + '" belongs to "' + product.title + '", not "' + strictTitle + '". Searching by title instead.');
                return searchByTitle();
            }
            return product;
        }, searchByTitle);
    }

    var lensRequestId = 0;

    function showSubtotal(origAmt, addAmt, curr){
        var newAmt = ((origAmt + addAmt)/100).toFixed(2);
        $('.rx-cart-amt').text(curr + numberWithCommas(newAmt));
    }

    // Shared helper: update running subtotal + resolve the lens variant id
    // UPDATED:
    //  - subtotal updates instantly from data-price (when set), so the price always shows
    //  - looks the lens up by handle, falls back to exact title search
    //  - Next stays disabled until the real lens is found, so a wrong/old lens never goes in the bag
    function updateLensAmountAndVariant($radio, val){
        var handle = $radio.data('handle'),
            title = $radio.data('title') || $radio.data('name'),
            listedPrice = parseInt($radio.data('price'), 10) || 0,
            origAmt = parseInt($('.rx-cart-amt').data('amt'), 10),
            curr = $('.rx-cart-amt').data('curr'),
            isSingleVision = $radio.hasClass('rx-singlevision-lens'),
            $nextBtn = $radio.closest('.journey-body').find('.rx-type-next-btn'),
            reqId = ++lensRequestId;

        // reset so a failed lookup never reuses the previous lens
        lensTypeId = '';
        showSubtotal(origAmt, listedPrice, curr);
        if(isSingleVision) $nextBtn.attr('disabled', true);

        findLensProduct(handle, title, $radio.data('title'))
            .done(function(product){
                if(reqId !== lensRequestId) return; // customer already picked another lens

                if(listedPrice && listedPrice !== product.price){
                    console.warn('Price check: "' + product.title + '" is ' + (product.price/100) + ' in Shopify but the option shows ' + (listedPrice/100) + '. The cart will charge the Shopify price - fix one of them.');
                }
                if(!listedPrice) showSubtotal(origAmt, product.price, curr);

                if($radio.data('color-step')){
                    buildEyezenColors(product); // customer picks the colour (variant) on the next step
                } else if(val !== 'transgen8'){
                    lensTypeId = product.variants[0].id;
                } else {
                    $.each(product.variants, function(_, variant){
                        if(variant.title === 'Grey') $('.rx-transgen8-grey').val(variant.id);
                        if(variant.title === 'Brown') $('.rx-transgen8-brown').val(variant.id);
                    });
                }

                if(isSingleVision) $nextBtn.removeAttr('disabled');
            })
            .fail(function(){
                if(reqId !== lensRequestId) return;
                $radio.closest('.journey-body').find('.rx-subtotal').first()
                    .before('<p class="mt-4 mb-0 text-danger text-center rx-lens-error">Sorry, this lens is not available online right now. Please choose another lens.</p>');
                console.error('LENS NOT FOUND on the storefront. Handle: "' + handle + '", title: "' + title + '". Publish this product to the Online Store sales channel and put its real handle in data-handle.');
                $nextBtn.attr('disabled', true);
            });
    }

    // =========================
    // Colour step - any lens radio with data-color-step="true" (Tinted, Eyezen Gen S, Eyezen Color Touch)
    // =========================
    var EYEZEN_SWATCHES = {
        'grey': '#8a8d8f', 'gray': '#8a8d8f', 'green': '#3f7d4e', 'brown': '#7b4a2a',
        'blue': '#2f5d9e', 'bronze': '#a8692e', 'beige': '#d9c3a0', 'pink': '#e9a6b3',
        'black': '#1a1a1a', 'gold': '#c9a227', 'yellow': '#e8c547', 'purple': '#6b4c8a', 'red': '#b3261e', 'orange': '#d9822b',
        'ruby': '#9b1b30', 'sapphire': '#1f4e79', 'amethyst': '#6b4c8a', 'emerald': '#1f7a5a', 'amber': '#c98a1b'
    };

    function buildEyezenColors(product){
        var $wrap = $('.eyeglasses-singlevision-eyezen .rx-eyezen-colors').empty();

        $.each(product.variants, function(_, v){
            var color = v.option1 || v.title,
                $input = $('<input type="radio" name="rx_lens_eyezen" class="rx-eyezen-color">')
                    .val(v.id)
                    .attr('data-name', color)
                    .attr('data-price', v.price),
                $dot = $('<span class="rx-chip-dot"></span>')
                    .css('background', EYEZEN_SWATCHES[String(color).toLowerCase()] || '#d0d0d0'),
                $text = $('<span></span>').text(color + (v.available ? '' : ' (Sold out)'));

            if(!v.available) $input.prop('disabled', true);

            $wrap.append(
                $('<label class="rx-chip-label"></label>').append(
                    $input,
                    $('<span class="rx-chip"></span>').append($dot, $text)
                )
            );
        });
    }

    $('#eyeglassesModal').on('change', '.rx-eyezen-color', function(){
        var color = $(this).data('name'),
            variantPrice = parseInt($(this).data('price'), 10) || 0,
            origAmt = parseInt($('.rx-cart-amt').data('amt'), 10),
            curr = $('.rx-cart-amt').data('curr'),
            $journey = $(this).closest('.journey-body');

        lensColor = color;
        lensTypeId = $(this).val();
        lensType = $('#eyeglassesModal .rx-singlevision-lens:checked').data('name') || lensType;

        $('.rx-lens-summary .rx-summary-selection').text(lensType);
        $('.rx-lens-summary').removeClass('d-none');
        $('.rx-lenscolor-summary .rx-summary-selection').text(color);
        $('.rx-lenscolor-summary').removeClass('d-none');

        if(variantPrice) showSubtotal(origAmt, variantPrice, curr);

        $journey.find('.progress').attr('aria-valuenow', '75');
        $journey.find('.progress-bar').css('width', '75%');
        $journey.find('.rx-type-next-btn').removeAttr('disabled');

        // Back from the prescription upload returns to the colour step
        $('.eyeglasses-singlevision-file').find('.btn-back').data('prev-step', '.eyeglasses-singlevision-eyezen');
    });

    // =========================
    // TransGen8 Color Selection
    // =========================
    $('#eyeglassesModal .rx-transgen8-color').on('change', function(){
        lensColor = $(this).data('name');
        lensTypeId = $(this).val();
        
        var $journey = $(this).closest('.journey-body');
        $journey.find('.progress').attr('aria-valuenow', '75');
        $journey.find('.progress-bar').css('width', '75%');
        $journey.find('.rx-type-next-btn').removeAttr('disabled');
    });

    // =========================
    // File input
    // =========================
    $('#eyeglassesModal .file-input').on('change', function(){
        const file = this.files[0];
        var handle = $(this).data('handle');

        if(file){
            $('#file-name').text(file.name);
            $('#upload-box').addClass('d-none');
            $('#file-box').removeClass('d-none');

            $('.eyeglasses-singlevision-file').find('.progress').attr('aria-valuenow', '100');
            $('.eyeglasses-singlevision-file').find('.progress-bar').css('width', '100%');

            $.getJSON(window.Shopify.routes.root + 'products/' + handle + '.js')
                .done(function(product){
                    if(product.variants.length) $('.uploadedFileProduct').val(product.variants[0].id);
                });

            $(this).closest('.singleVisionForm').find('.rx-type-next-btn').removeAttr('disabled');
        } else {
            // No file chosen (e.g. picker cancelled) - show the upload box again and keep Add to Bag disabled
            $('#file-name').text('');
            $('#file-box').addClass('d-none');
            $('#upload-box').removeClass('d-none');
            $('.uploadedFileProduct').val('');
        }

        updatePrescriptionSubmit();
    });

    // "Change" button - open the file picker again
    $('#eyeglassesModal').on('click', '#change-btn', function(e){
        e.preventDefault();
        $('#eyeglassesModal .eyeglasses-singlevision-file .file-input').trigger('click');
    });

    // =========================
    // Navigation - Eyeglasses
    // =========================
    $('.btn-back').on('click', function(){
        var prevStep = $(this).data('prev-step');
        showStep(prevStep.replace('.', ''));
    });

    $('#eyeglassesModal').on('click', '.rx-type-next-btn', function(){
        var nextStep = $(this).data('next-step');
        if(nextStep) showStep(nextStep.replace('.', ''));
    });

    // =========================
    // Navigation - Contact Lenses
    // ✅ FIX: Added delegated handler for contact lens modal navigation
    // =========================
    $('#contactLensesModal').on('click', '.rx-type-next-btn:not(.rx-form-submit)', function(){
        var nextStep = $(this).data('next-step');
        if(nextStep) showContactStep(nextStep);
    });

    $('#contactLensesModal').on('click', '.btn-back', function(){
        var prevStep = $(this).data('prev-step');
        if(prevStep) showContactStep(prevStep);
    });

    // Adds 'Lens Color' to cart line properties when a colour was chosen (shows in cart, checkout and the order)
    function withLensColor(props){
        if(lensColor) props['Lens Color'] = lensColor;
        return props;
    }

    // fetch() doesn't fail on HTTP errors - treat a rejected /cart/add.js as an error
    function checkCartResponse(r){
        return r.json().then(function(data){
            if(!r.ok) throw new Error(data && (data.description || data.message) || 'Cart error');
            return data;
        });
    }

    // =========================
    // Add to Bag - Single Vision + File
    // =========================
    $('.eyeglasses-singlevision-file .rx-form-submit').on('click', function(e){
        e.preventDefault();

        // Block Add to Bag when no prescription file is uploaded
        if(!hasPrescriptionFile()){
            updatePrescriptionSubmit();
            alert('Please upload your prescription before adding to bag.');
            return;
        }

        const cartReference = 'eyeglasses-' + Date.now();

        $('#eyeglassesModal .journey-body').addClass('d-none');
        $('#eyeglassesModal .journey-preloader').removeClass('d-none');

        fetch('/cart/add.js', {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body: JSON.stringify({
                items:[{
                    id: mainProductId,
                    quantity:1,
                    properties: withLensColor({
                        'Prescription Type': prescriptionType,
                        'Lens Type': lensType,
                        'cart_reference': cartReference
                    })
                }]
            })
        })
        .then(checkCartResponse)
        .then(() => {
            return fetch('/cart/add.js', {
                method:'POST',
                headers:{'Content-Type':'application/json'},
                body: JSON.stringify({
                    items:[{
                        id:lensTypeId,
                        quantity:1,
                        properties: withLensColor({'cart_reference': cartReference})
                    }]
                })
            });
        })
        .then(checkCartResponse)
        .then(() => {
            const form = $('.singleVisionForm')[0];
            const formData = new FormData(form);
            formData.set('properties[cart_reference]', cartReference);

            return fetch('/cart/add.js',{
                method:'POST',
                body: formData
            });
        })
        .then(r => r.json())
        .then(() => {
            $('#eyeglassesModal .journey-body').addClass('d-none');
            $('#eyeglassesModal .journey-success').removeClass('d-none');
        })
        .catch(err => {
            console.error('❌ Error:', err);
            $('#eyeglassesModal .journey-body').addClass('d-none');
            $('#eyeglassesModal .journey-error').removeClass('d-none');
        });
    });

    // =========================
    // Add to Bag - TransGen8
    // =========================
    $('.eyeglasses-singlevision-transgen8 .rx-form-submit').on('click', function(e){
        e.preventDefault();
        const cartReference = 'eyeglasses-' + Date.now();

        $('#eyeglassesModal .journey-body').addClass('d-none');
        $('#eyeglassesModal .journey-preloader').removeClass('d-none');

        fetch('/cart/add.js',{
            method:'POST', 
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify({
                items:[{
                    id: mainProductId,
                    quantity:1,
                    properties:{
                        'Prescription Type': prescriptionType,
                        'Lens Type': lensType,
                        'Lens Color': lensColor,
                        'cart_reference': cartReference
                    }
                }]
            })
        })
        .then(r => r.json())
        .then(() => {
            return fetch('/cart/add.js',{
                method:'POST',
                headers:{'Content-Type':'application/json'},
                body:JSON.stringify({
                    items:[{
                        id:lensTypeId,
                        quantity:1,
                        properties:{'cart_reference': cartReference}
                    }]
                })
            });
        })
        .then(r => r.json())
        .then(() => {
            $('#eyeglassesModal .journey-body').addClass('d-none');
            $('#eyeglassesModal .journey-success').removeClass('d-none');
        })
        .catch(err => {
            console.error('❌ Error:', err);
            $('#eyeglassesModal .journey-body').addClass('d-none');
            $('#eyeglassesModal .journey-error').removeClass('d-none');
        });
    });

    // =========================
    // Add to Bag - Non-Graded
    // =========================
    $('.eyeglasses-nongraded .rx-form-submit').on('click', function(e){
        e.preventDefault();
        const cartReference = 'eyeglasses-' + Date.now();

        $('#eyeglassesModal .journey-body').addClass('d-none');
        $('#eyeglassesModal .journey-preloader').removeClass('d-none');

        fetch('/cart/add.js',{
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify({
                items:[{
                    id: mainProductId,
                    quantity:1,
                    properties:{
                        'Prescription Type': prescriptionType,
                        'Lens Type': lensType,
                        'cart_reference': cartReference
                    }
                }]
            })
        })
        .then(r => r.json())
        .then(() => {
            return fetch('/cart/add.js',{
                method:'POST',
                headers:{'Content-Type':'application/json'},
                body:JSON.stringify({
                    items:[{
                        id:lensTypeId,
                        quantity:1,
                        properties:{'cart_reference': cartReference}
                    }]
                })
            });
        })
        .then(r => r.json())
        .then(() => {
            $('#eyeglassesModal .journey-body').addClass('d-none');
            $('#eyeglassesModal .journey-success').removeClass('d-none');
        })
        .catch(err => {
            console.error('❌ Error:', err);
            $('#eyeglassesModal .journey-body').addClass('d-none');
            $('#eyeglassesModal .journey-error').removeClass('d-none');
        });
    });

    // =========================
    // Add to Bag - Contact Lenses
    // ✅ FIX: Scoped all journey selectors to #contactLensesModal
    // =========================
   /* $('#contactLensesModal').on('click', '.rx-form-submit', function(e){
        e.preventDefault();
        const cartReference = 'contactlens-' + Date.now();
        
        const rightGradeId      = $('.right-grade').val();
        const rightBoxes        = parseInt($('.right-grade-boxes').val()) || 1;
        const leftGradeId       = $('.left-grade').val();
        const leftBoxes         = parseInt($('.left-grade-boxes').val()) || 1;
        const rightGradeName    = $('.right-grade option:selected').data('grade');
        const leftGradeName     = $('.left-grade option:selected').data('grade');
        
        if(!rightGradeId || !leftGradeId){
            alert('Please select lens power for both eyes');
            return;
        }

        // ✅ Scoped to contact lens modal only
        $('#contactLensesModal .journey-body').addClass('d-none');
        $('#contactLensesModal .journey-preloader').removeClass('d-none');

        const items = [];
        
        if(rightBoxes > 0){
            items.push({
                id: rightGradeId,
                quantity: rightBoxes,
                properties: {
                    'Eye': 'Right Eye (OD)',
                    'Power': rightGradeName,
                    'cart_reference': cartReference
                }
            });
        }
        
        if(leftBoxes > 0){
            items.push({
                id: leftGradeId,
                quantity: leftBoxes,
                properties: {
                    'Eye': 'Left Eye (OS)',
                    'Power': leftGradeName,
                    'cart_reference': cartReference
                }
            });
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({ items: items })
        })
        .then(r => r.json())
        .then(() => {
            $('#contactLensesModal .journey-body').addClass('d-none');
            $('#contactLensesModal .journey-success').removeClass('d-none');
        })
        .catch(err => {
            console.error('❌ Error:', err);
            $('#contactLensesModal .journey-body').addClass('d-none');
            $('#contactLensesModal .journey-error').removeClass('d-none');
        });
    }); */

    // =========================
    // Remove Eyeglasses Set
    // =========================
    window.removeEyeglassesSet = function(cartReference){
        if(!cartReference){
            console.error('❌ No cart reference provided');
            return;
        }

        return fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
                const updates = {};
                let count = 0;
                
                cart.items.forEach(item => {
                    if(item.properties && item.properties.cart_reference === cartReference){
                        updates[item.key] = 0;
                        count++;
                    }
                });

                if(count === 0){
                    alert('No items found to remove');
                    return Promise.reject('No items found');
                }

                return fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({ updates: updates })
                });
            })
            .then(r => r.json())
            .then(() => {
                location.reload();
            })
            .catch(err => {
                console.error('❌ Removal error:', err);
            });
    };

    $(document).on('click', '.remove-item-link', function(e){
        e.preventDefault();
        e.stopPropagation();
        
        const cartRef = $(this).attr('data-cart-ref') || $(this).data('cart-ref');
        
        if(cartRef && cartRef !== 'undefined' && cartRef !== ''){
            window.removeEyeglassesSet(cartRef);
        } else {
            console.error('❌ Invalid cart_reference');
            alert('Cannot remove: Invalid reference');
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service"] && !Shopify.designMode) return;
  try {
    
$(function(){
    var $firstName = $('#firstName'),
        $lastName = $('#lastName'),
        $email = $('#email'),
        $mobileNo = $('#mobileNo'),
        $birthMonth = $('#birthMonth'),
        $birthDate = $('#birthDate'),
        $birthYear = $('#birthYear');

    function computeAge(){
        let month = parseInt($birthMonth.val());
        let day   = parseInt($birthDate.val());
        let year  = parseInt($birthYear.val());

        if(!month || !day || !year) return; // wait until all 3 are selected

        const today = new Date();
        const birth = new Date(year, month - 1, day);

        let age = today.getFullYear() - birth.getFullYear();

        // check if birthday has not occurred yet this year
        const hasBirthdayPassed =
            today.getMonth() > birth.getMonth() ||
            (today.getMonth() === birth.getMonth() &&
            today.getDate() >= birth.getDate());

        if(!hasBirthdayPassed) {
            age--;
        }

        console.log("Age:", age);
        //$("#ageOutput").text(age); // optional: display somewhere
    }

    $firstName.on('change', function(){
        $('#t-first_name-0').val($(this).val());
    });

    $lastName.on('change', function(){
        $('#t-last_name-1').val($(this).val());
    });

    $email.on('change', function(){
        $('#t-email-3').val($(this).val());
    });

    $mobileNo.on('change', function(){
        $('#phone_number-2').val($(this).val());
    });

    $birthMonth.on('change', computeAge);

    $birthDate.on('change', computeAge);

    $birthYear.on('change', computeAge);
});

  } catch(e) { console.error(e); }
})();
})();
